import {
  calculateColumnWidth,
  mapColumnTypes,
  selectColumnFactory,
  TYPES,
} from "@/react/components/table";
import { getColumnDef } from "@/react/schema/schemaFields";
import schema from "./schema";
import * as yup from "yup";
import { AddressCell } from "@/react/features/support-tools/siptrunk/dids/AddressCell";
import Tooltip from "@8x8/oxygen-tooltip";
import {
  isEmptyFilterFn,
  isntEmptyFilterFn,
  StringFilter,
  StringFilterDisplay,
} from "@/react/components/table/components/filter/filters";

const getFreeFormValue = (row, columnId) => {
  const value = row.getValue(columnId);
  return typeof value === "object" ? value?.freeForm || "" : value;
};

const addressFilterFns = new Map([
  [
    "contains",
    {
      label: "Contains",
      filterFn: (row, columnId, filterValue) => {
        return getFreeFormValue(row, columnId)
          .toLowerCase()
          .includes(filterValue.toLowerCase());
      },
      filterComponent: StringFilter,
      displayComponent: StringFilterDisplay,
    },
  ],
  [
    "is",
    {
      label: "Is",
      filterFn: (row, columnId, filterValue) => {
        return (
          getFreeFormValue(row, columnId).toLowerCase() ===
          filterValue.toLowerCase()
        );
      },
      filterComponent: StringFilter,
      displayComponent: StringFilterDisplay,
    },
  ],
  isEmptyFilterFn,
  isntEmptyFilterFn,
]);

const columnDefinition = () =>
  calculateColumnWidth(
    [
      selectColumnFactory(),
      {
        ...getColumnDef(schema.fields.phoneNumber, "Phone Number"),
        type: TYPES.ID,
      },
      {
        ...getColumnDef(schema.fields.address, "Emergency Address"),
        editable: true,
        cell: ({ getValue }) => (
          <Tooltip title={getValue()?.freeForm}>{getValue()?.freeForm}</Tooltip>
        ),
        accessorFn: (row) => row.address, // Keeps the full object for editing
        editableCell: AddressCell,
        filterFns: addressFilterFns,
        filterComponent: StringFilter,
      },
      {
        ...getColumnDef(
          yup.reach(schema, "emergencyDetails.firstName"),
          "First Name",
          "Emergency Contact Details - First Name"
        ),
        editable: true,
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(
          yup.reach(schema, "emergencyDetails.lastName"),
          "Last Name",
          "Emergency Contact Details - Last Name"
        ),
        editable: true,
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(
          yup.reach(schema, "emergencyDetails.email"),
          "Email",
          "Emergency Contact Details - Email"
        ),
        editable: true,
        type: TYPES.STRING,
      },
    ].map(mapColumnTypes)
  );

export default columnDefinition;
